// Formatting helpers configured by the installation's public product settings.
const MONTHS_ID = ['Jan','Feb','Mar','Apr','Mei','Jun','Jul','Agu','Sep','Okt','Nov','Des'];
const MONTHS_EN = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
let activeCurrency = 'IDR';
let activeLanguage = 'id';

export function configureFormatting({ currency = 'IDR', language = 'id' } = {}) {
  activeCurrency = currency;
  activeLanguage = language;
}

export function formatRp(n, opts = {}) {
  const num = Number(n || 0);
  return new Intl.NumberFormat(activeLanguage === 'en' ? 'en-US' : 'id-ID', {
    style: 'currency', currency: activeCurrency,
    maximumFractionDigits: 0,
    notation: opts.compact ? 'compact' : 'standard',
    compactDisplay: 'short',
  }).format(num);
}

export function formatNumber(n) {
  const num = Number(n || 0);
  return num.toLocaleString(activeLanguage === 'en' ? 'en-US' : 'id-ID', { maximumFractionDigits: 2 });
}

export function formatDate(d) {
  if (!d) return '-';
  const raw = typeof d === 'string' ? d.substring(0, 10) : '';
  const parts = raw.split('-');
  if (parts.length !== 3) return d;
  const [y, m, day] = parts;
  const mi = parseInt(m, 10) - 1;
  if (isNaN(mi)) return d;
  const months = activeLanguage === 'en' ? MONTHS_EN : MONTHS_ID;
  return `${day} ${months[mi]} ${y}`;
}

export function todayISO() {
  const t = new Date();
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, '0');
  const d = String(t.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function parseNumberInput(v) {
  if (v === null || v === undefined || v === '') return 0;
  const cleaned = String(v).replace(/[^0-9,.-]/g, '').replace(/\./g, '').replace(',', '.');
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
}
